<template>
  <div class="transfer__wrapper transfer-payment-method">
    <!-- Шаг 1: Выбор метода оплаты -->
    <form-layout
      v-if="currentStep === 1"
      :main-title="$t('transfer.title')"
      :mobile-title="$t('transfer.titleMobile')"
      :small-title="true"
      submit-text="Далее"
      @back="goBack"
      @submit="goToNextStep"
    >
      <div class="payments-content__body">
        <Loader v-if="loading" />
        <div class="payments-content__body__header">
          <div class="payments-content__body__header__left">
            <div class="payments-content__body__header__image">
              <img src="@/assets/images/payments/payments-ico.svg" alt="ico" />
            </div>
            <span>
              {{ $t('payment.selectPaymentMethod') }}
            </span>
          </div>

          <!-- <div class="payments-content__body__header__right">
            <CountrySelect v-model="filters.country" :countries="countries" />
          </div> -->
        </div>
        <PaymentMethodsList :current="selectedMethodName" :list="methodsInCustomOrder" @select="choosePaymentMethod" />
      </div>

      <div class="payments-content__info">
        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.replenishmentAmount') }}</div>
          <Input
            v-model.trim="amount"
            type="number"
            :icon-text="currencyMap[$store.state.currency]"
            :placeholder="$t('payment.enterSum')"
            :state="error.message ? 'error' : 'default'"
            :error="error.message"
            :disabled="true"
            @keyup.enter="goToNextStep"
            @blur="validatePrice"
          />
        </div>

        <div v-if="isNeedEmail" class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.email') }}</div>
          <Input
            v-model.trim="email"
            icon-text="%"
            placeholder="E-mail"
            :state="emailError.message ? 'error' : 'default'"
            :error="emailError.message"
            :disabled="true"
            @keyup.enter="goToNextStep"
          />
        </div>

        <div class="payments-content__info__wrap">
          <div class="payments-content__info__title">{{ $t('payment.commission') }}:</div>
          <Input
            v-model.trim="commissionValue"
            icon-text="%"
            :placeholder="$t('payment.commission')"
            :disabled="true"
            @keyup.enter="goToNextStep"
          />
        </div>
      </div>
    </form-layout>

    <!-- Шаг 2: Подтверждение оплаты -->
    <form-layout
      v-if="currentStep === 2"
      :main-title="$t('transfer.title')"
      :mobile-title="$t('transfer.titleMobile')"
      title="Проверьте данные"
      sub-title="Еще раз перед оплатой проверьте все данные"
      :small-title="true"
      :submit-text="$t('payment.pay')"
      :disabled="loading"
      @back="currentStep = 1"
      @submit="createOrder"
    >
      <div class="payments-step-2">
        <div class="payments-step-2__info">
          <Input
            :value="$store.state.paymentsOrder.robloxNickname"
            :disabled="true"
            icon="/base/user.svg"
            placeholder="Roblox никнейм"
          />
          <div class="payments-step-2__method">
            <Input :value="paymentMethodName" :disabled="true" icon="/base/payment.svg" placeholder="Метод оплаты" />
            <span class="payments-step-2__method-commission">
              Комиссия {{ $store.state.paymentsOrder.selectedMethod.commission }}%
            </span>
          </div>
          <div class="payments-step-2__infoPay">
            <div class="payments-step-2__robux-block">
              <Input
                :value="$store.state.paymentsOrder.robuxAmount + ' R$'"
                :disabled="true"
                icon="/base/robux.svg"
                placeholder="Робуксы"
              />
              <p v-if="$store.state.promoCode.bonus" class="payments-step-2__promo-bonus">
                <span class="green">+{{ $store.state.promoCode.bonus }} R$</span>
              </p>
            </div>
            <Input
              :value="$store.state.paymentsOrder.commissionValue + ' ' + currencyMap[$store.state.currency]"
              :disabled="true"
              :icon-text="currencyMap[$store.state.currency]"
              :placeholder="$t('payment.commission')"
            />
          </div>
          <Alert
            state="warning"
            class="payments-step-2__infoAlert"
            :title="$t('general.warning')"
            :info="$t('transfer.subTitle')"
          />
        </div>

        <p class="payments-step-2__result">
          {{ $t('payment.toPay') }}:
          <span>
            {{ $store.state.paymentsOrder.totalToPay }}
            {{ currencyMap[$store.state.currency] }}
          </span>
        </p>
      </div>
    </form-layout>
  </div>
</template>

<script>
import languages from '@/constants/languages'
import paymentsMethodsInfo from '@/constants/paymentsMethodsInfo'
import { validateEmail } from '@/utils/validate'
import { getCommissionNewLava } from '@/utils/formatting'
import { getPaymentMethodName, makePayment } from '@/utils/paymentMethods'
import { mapGetters } from 'vuex'
import Loader from '@/components/LoaderBar/LoaderBar'
import ipUtil from '@/utils/ip'
import Input from '@/components/Base/Input/Input.vue'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import PaymentMethodsList from '@/components/PaymentMethodsList/PaymentMethodsList.vue'
import Alert from '@/components/Base/Alert/Alert.vue'

import { METHODS_ORDER } from '@/constants/paymentMethods'
import paymentSubStep from '@/mixins/paymentSubStep'

export default {
  name: 'TransferPaymentMethod',
  components: {
    Alert,
    PaymentMethodsList,
    FormLayout,
    Input,
    Loader
  },
  inject: ['currencyMap'],
  mixins: [paymentSubStep],
  props: {
    isTransferOrSuperPass: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentStep: 1,
      selectedMethod: {
        name: '',
        currency: '',
        commission: 0,
        email: null,
        method: null,
        key: null
      },
      ipCountry: 'EU',
      languages,
      countryList: {
        RU: ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR', 'TH', 'ID', 'PH', 'MY', 'VN', 'HK'],
        EN: ['EU', 'USA', 'UA', 'MX', 'PE', 'UY', 'CL', 'BR', 'TH', 'ID', 'PH', 'MY', 'VN', 'HK']
      },

      paymentMethod: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToGatewayMap)),
      paymentSystemsMap: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsToSystemMap)),
      methodMaps: JSON.parse(JSON.stringify(paymentsMethodsInfo.methodsConfig)),
      allMethods: JSON.parse(JSON.stringify(paymentsMethodsInfo.allMethods)),

      filters: {
        country: 'RU',
        currency: 'RUB'
      },

      currencyRate: {
        RUB: 1,
        USD: 73,
        EUR: 80,
        EURUSD: 1,
        USDEUR: 1
      },

      amount: null,
      originalAmount: null,
      email: '',
      error: {
        status: false,
        show: false,
        message: ''
      },
      emailError: {
        status: false,
        show: false,
        message: ''
      },
      loading: false,
      newCommissions: []
    }
  },
  created() {
    this.getNewCommission()
    // Установить сумму из стора и сохранить оригинальную сумму покупки
    this.originalAmount = this.$store.state.paymentsOrder.amount
    this.amount = this.originalAmount
  },
  mounted() {
    this.setUserRegion()
  },
  computed: {
    ...mapGetters(['currency', 'language', 'country']),
    paymentMethodName() {
      return getPaymentMethodName(this.selectedMethod.name)
    },
    isRussian() {
      return this.language === 'ru'
    },
    countries() {
      return this.countryList[this.language.toUpperCase()] || this.countryList.EN
    },
    selectedCountry() {
      return this.filters.country
    },
    selectedLanguage() {
      for (const language of languages) {
        if (this.filters.country === language.name.toUpperCase()) {
          return language
        }
      }

      return languages[0]
    },
    filteredMethods: function() {
      // DEPRECATED
      // const filterByCurrency = m => {
      //   return this.filters.currency === 'ALL' ? true : this.methodMaps[m].currency.includes(this.filters.currency)
      // }
      // const filterByCountry = m => {
      //   if (this.methodMaps[m].disableForRu) {
      //     return !this.isCountryRu(this.$store.state.ipCountry)
      //   } // Скрыть для русского ip
      //   return this.methodMaps[m].country.includes(this.selectedCountry)
      // }
      const sortByPriority = (a, b) => {
        return this.methodMaps[a.key]?.priority[this.selectedCountry] >
          this.methodMaps[b.key]?.priority[this.selectedCountry]
          ? 1
          : -1
      }

      const generateMultiCurrencyList = methods => {
        // const currency = this.filters.country !== 'RU' ? 'USD' : this.currency
        return methods
          .map(m => {
            // if (!this.methodMaps[m].currency.includes(this.currency)) {
            //   return this.methodMaps[m].currency.map(c => {
            //     return {
            //       key: m,
            //       name: m,
            //       currency: c,
            //       commission: this.getMethodCommission(m),
            //       iconType: this.methodMaps[m].iconType,
            //       iconName: this.methodMaps[m].iconName,
            //       email: this.methodMaps[m].email,
            //       min: this.methodMaps[m]?.min?.default
            //     }
            //   })
            // }
            return {
              key: m,
              name: m,
              currency: 'rub',
              commission: this.getMethodCommission(m),
              iconType: this.methodMaps[m].iconType,
              iconName: this.methodMaps[m].iconName,
              min: this.methodMaps[m]?.min?.default,
              email: this.methodMaps[m].email
            }
          })
          .flat()
      }
      // DEPRECATED
      // let filteredMethods = this.allMethods.filter(m => filterByCountry(m) && filterByCurrency(m))
      let filteredMethods = this.allMethods
      if (this.filters.currency === 'ALL') {
        filteredMethods = generateMultiCurrencyList(filteredMethods)
      } else {
        filteredMethods = filteredMethods.map(m => ({
          key: m,
          currency: this.filters.currency,
          commission: this.getMethodCommission(m),
          iconType: this.methodMaps[m].iconType,
          iconName: this.methodMaps[m].iconName,
          min: this.methodMaps[m]?.min?.default
        }))
      }
      return filteredMethods
        .sort((a, b) => sortByPriority(a, b))
        .filter((item, index, self) => {
          return index === self.findIndex(obj => obj.key === item.key)
        })
    },
    commissionValue() {
      if (!this.selectedMethod.name || !this.amount) return ''

      const method = this.selectedMethod.name

      if (this.shouldReturnUnknown(method)) {
        return 'Unknown'
      }

      if (this.isQiwiMethod(method)) {
        return this.calculateQiwiCommission()
      }

      const commission = this.calculateCommissionRate(method)
      const amount = Number(this.amount)

      const multipliedResult = this.calculateWithMultipliers(method, amount, commission)
      if (multipliedResult !== null) {
        return multipliedResult
      }

      if (this.paymentSystemsMap[method] === 'gm') {
        const fixFee = this.methodMaps[method]?.fix?.[this.currency] || 0
        return this.getPrice(amount, commission, fixFee).toFixed(2)
      }

      if (this.paymentSystemsMap[method] === 'gram') {
        return this.calculateGramCommission(amount)
      }

      return this.getPrice(amount, commission, 0, this.shouldUseLavaCalculation(method))
    },
    paymentIsRub() {
      return ['rub_card', 'lava', 'card_gm', 'sbp_gm', ...METHODS_ORDER].includes(this.selectedMethod.name)
    },
    isNeedEmail() {
      return this.selectedMethod.email
    },
    methodsInCustomOrder() {
      const methods = [...this.newCommissions, ...this.filteredMethods]

      const orderedMethods = this.getMethodsWithOrder(methods)

      return orderedMethods.length ? orderedMethods : methods
    },
    selectedMethodName() {
      return this.selectedMethod.method || this.selectedMethod.key
    }
  },
  watch: {
    // language(value) {
    // if (value === 'ru' && this.filters.country === 'EU') {
    //   this.filters.country = 'RU'
    // }
    //
    // if (value === 'en' && this.filters.country === 'RU') {
    //   this.filters.country = 'EU'
    // }
    //
    // if (value !== 'ru' && this.filters.currency === 'RUB') {
    //   this.filters.currency = 'USD'
    // }
    //
    // const defaultMethod = this.filteredMethods[0]
    // this.choosePaymentMethod(defaultMethod)
    // },
    // currency(value) {
    //   const defaultMethod = this.filteredMethods[0]
    //   this.choosePaymentMethod(defaultMethod.currency)
    // },
    // 'filters.country'(val) {
    //   if (!['RU', 'UA'].includes(val) && this.filters.currency === 'RUB') {
    //     this.filters.currency = 'USD'
    //   }
    // },
    amount(val) {
      if (
        this.filters.country === 'USA' &&
        this.selectedMethod.name.includes('card') &&
        this.currency.toUpperCase() === 'USD' &&
        +val > 50
      ) {
        this.amount = 50
      }
    },
    'selectedMethod.name': function(val) {
      if (val) {
        const minVar = this.methodMaps[val].min
        let minVal = null
        if (typeof minVar === 'object') {
          minVal = minVar[this.currency.toUpperCase()]
        } else {
          minVal = minVar
        }
        // Устанавливаем сумму как максимум из оригинальной суммы покупки и минимума платежки
        // Это гарантирует, что при переключении на платежку с меньшей минималкой
        // сумма вернется к оригинальной, если она выше новой минималки
        if (this.originalAmount && this.originalAmount >= minVal) {
          this.amount = this.originalAmount
        } else {
          this.amount = this.ceil(minVal, 2)
        }
      }
    }
  },
  methods: {
    getCommissionNewLava,

    goBack() {
      this.$emit('changeModal', {
        modal: 'TransferPrivatPlace'
      })
    },

    goToNextStep() {
      if (!this.selectedMethod.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.empty'),
          type: 'error'
        })
        return
      }

      if (this.paymentIsRub) {
        this.validatePrice()
      }
      if (this.isNeedEmail) {
        this.validateEmail()
      }

      const errorMessage = this.error.message || this.emailError.message

      if (errorMessage) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: errorMessage,
          type: 'error'
        })
        return
      }

      // Сохранение данных текущего шага в store
      this.$store.commit('paymentsOrder/setAmount', Number(this.amount))
      this.$store.commit('paymentsOrder/setCurrency', this.currency)
      this.$store.commit('paymentsOrder/setEmail', this.email)
      this.$store.commit('paymentsOrder/setSelectedMethod', {
        name: this.selectedMethod.name,
        key: this.selectedMethod.key,
        commission: this.selectedMethod.commission,
        iconType: this.selectedMethod.iconType,
        iconName: this.selectedMethod.iconName
      })
      this.$store.commit('paymentsOrder/setCommission', this.commissionValue)
      this.$store.commit('paymentsOrder/setTotalToPay', this.commissionValue)

      // Переход на шаг 2 для подтверждения
      this.currentStep = 2
    },

    isCountryRu(c) {
      return ipUtil.isCountryRu(c)
    },

    getMethodCommission(method) {
      if (typeof this.methodMaps[method].commission === 'object') {
        const key = Object.keys(this.methodMaps[method].commission)
        if (key.includes(this.filters.country)) {
          return this.methodMaps[method].commission[this.filters.country]
        }
        return this.methodMaps[method].commission.default
      }
      return this.methodMaps[method].commission
    },

    setUserRegion() {
      const EU_COUNRIES = [
        'AU',
        'BE',
        'BG',
        'GB',
        'HU',
        'DE',
        'GR',
        'DK',
        'IE',
        'ES',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'LI',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'FI',
        'FR',
        'HR',
        'CZ',
        'SE',
        'EE',
        'BA',
        'IE',
        'IS',
        'NO'
      ]
      const RU_COUNRIES = ['AZ', 'AM', 'BY', 'KZ', 'KG', 'MD', 'TJ', 'UZ', 'TM', 'GE']
      const SELECTED_COUNTRIES = ['RU', 'UA', 'EU', 'USA', 'MX', 'PE', 'UY', 'CL', 'BR']

      if (EU_COUNRIES.includes(this.country)) {
        this.filters.country = 'EU'
      } else if (RU_COUNRIES.includes(this.country)) {
        this.filters.country = 'RU'
      } else if (SELECTED_COUNTRIES.includes(this.country)) {
        this.filters.country = this.country
      } else {
        this.filters.country = 'RU'
      }
    },

    ceil(value, decimals) {
      return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
    },

    async createOrder() {
      if (!this.selectedMethod.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.empty'),
          type: 'error'
        })
        return
      }

      if (this.paymentIsRub) {
        this.validatePrice()
      }

      const errorMessage = this.error.message || this.emailError.message

      if (errorMessage) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: errorMessage,
          type: 'error'
        })
        return
      }

      this.loading = true

      try {
        // Шаг 1: Создаем заказ (Transfer или SuperPass)
        // flag=true означает transfer/depot (наш вариант)
        const orderResult = await this.$store.dispatch('paymentsOrder/makeOrder', {
          withReplenish: true
        })

        if (!orderResult) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: this.$t('payment.errors.server'),
            type: 'error'
          })
          this.loading = false
          return
        }

        // Проверка на status: false в ответе
        if (orderResult.status === false) {
          const errorMessage = orderResult.message || orderResult.error || 'Не удалось создать заказ'
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: errorMessage,
            type: 'error'
          })
          this.loading = false
          return
        }

        // Обработка ответа - проверяем, что error не пустая строка
        if (orderResult.error && orderResult.error.length > 0) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: orderResult.error,
            type: 'error'
          })
          this.loading = false
          return
        }

        // Получаем ID заказа из разных вариантов структуры ответа
        // Для transfer: orderResult.order._id
        // Для SuperPass: orderResult.data._id или orderResult.data.id
        const orderId = orderResult?.order?._id || orderResult?.data?._id || orderResult?.data?.id || orderResult?.id

        if (!orderId) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: 'Не удалось получить ID заказа',
            type: 'error'
          })
          this.loading = false
          return
        }

        // Получаем userId из store
        const userId = this.$store.state.account.userId

        if (!userId) {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: 'Не удалось получить ID пользователя',
            type: 'error'
          })
          this.loading = false
          return
        }

        // Шаг 2: Создаем платеж через makePayment
        const paymentResult = await makePayment(
          {
            name: this.selectedMethod.name,
            key: this.selectedMethod.key,
            method: this.selectedMethod.method
          },
          orderId,
          userId,
          Number(this.amount),
          this.email,
          this.currency
        )

        if (paymentResult?.redirect_uri) {
          // Определяем источник для аналитики
          const isSuperPass = this.$store.state.paymentsOrder.isSuperPass
          const source = isSuperPass ? 'superpass' : 'transfer'

          // Отправляем аналитику
          this.$analytics.send('topup', {
            topup_id: paymentResult.id || orderId,
            source: source
          })

          // Перенаправляем на страницу оплаты
          location.href = paymentResult.redirect_uri
        } else {
          const isSuperPass = this.$store.state.paymentsOrder.isSuperPass
          const source = isSuperPass ? 'superpass' : 'transfer'

          this.$analytics.send('topup_error', {
            source: source
          })

          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: 'Не удалось создать платеж. Попробуйте позже',
            type: 'error'
          })
        }
      } catch (error) {
        const isSuperPass = this.$store.state.paymentsOrder.isSuperPass
        const source = isSuperPass ? 'superpass' : 'transfer'

        this.$analytics.send('topup_error', {
          source: source
        })

        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.server'),
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },

    extractPaymentUrl(orderResult) {
      // Для SuperPass ответ может быть { data, error }
      const data = orderResult.data || orderResult

      // Проверяем различные варианты ссылок на оплату
      if (data.pay_url || data.payUrl || data.url) {
        return data.pay_url || data.payUrl || data.url
      }

      // Если есть вложенные объекты с uri
      if (data.pay_ok?.uri) return data.pay_ok.uri
      if (data.new_fk?.uri) return data.new_fk.uri
      if (data.gram?.uri) return data.gram.uri
      if (data.gm?.uri) return data.gm.uri
      if (data.lava?.uri) return data.lava.uri
      if (data.antilopay?.uri) return data.antilopay.uri
      if (data.cardlink?.uri) return data.cardlink.uri
      if (data.overpay) return data.overpay

      return null
    },

    handleResponse(data) {
      const source = 'direct'
      if (data.pay_ok) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.pay_ok.uri
        return
      }
      if (data.new_fk) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.new_fk.uri
        return
      }
      if (data.gram) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.gram.uri
        return
      }
      if (data.gm) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.gm.uri
        return
      }
      if (data.lava) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.lava.uri
        return
      }
      this.$analytics.send('topup_error', {
        source
      })
      if (data.antilopay) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.antilopay.uri
      }
      if (data.cardlink) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.cardlink.uri
      }
      if (data.overpay) {
        this.$analytics.send('topup', {
          topup_id: data?.id,
          source
        })
        location.href = data.overpay
      }
    },

    createRequestBody() {
      let method
      const methodName = this.selectedMethod.name

      if (methodName === 'cardlink') {
        method = 'BANK_CARD'
      }

      if (methodName === 'cardlink_sbp') {
        method = 'SBP'
      }

      if (methodName === 'cardlink_sberpay') {
        method = 'SBERPAY'
      }

      if (methodName === 'overpay') {
        method = 'credit_card'
      }

      if (methodName === 'overpay_sbp') {
        method = 'sbp'
      }

      method = method || this.selectedMethod.method
      const type = method ? { payment_type: method } : {}

      const body = {
        amount: parseFloat(this.amount),
        paymentSystem: this.paymentSystemsMap[methodName],
        currency: this.currency.toLowerCase(),
        email: this.email || '',
        ...type
      }

      if (methodName === 'gram') {
        body.gramGateway = this.paymentMethod[methodName]
        return body
      }

      if (methodName === 'qiwi') {
        body.gameMoneyGateway = 'qiwi'
        body.paymentSystem = 'gm'
        body.gameMoneyRedirectOn = true
      }

      body.gameMoneyGateway =
        methodName === 'gm' || methodName === 'payok' || (methodName === 'new_fk') === 'lava'
          ? null
          : this.paymentMethod[methodName]

      if (methodName !== 'gm' && this.paymentSystemsMap[methodName] === 'gm') {
        body.gameMoneyRedirectOn = true
      }

      if (methodName === 'card_gm_ua') {
        body.gameMoneyUserCurrency = 'uah'
      }

      if (methodName === 'card_gm_br') {
        body.gameMoneyUserCurrency = 'brl'
      }

      if (methodName === 'lava_card') {
        body.paymentSystem = 'lava'
      }

      if (methodName === 'antilopay') {
        body.paymentSystem = 'antilopay'
        body.antilopayGateway = 'antilopay_sberpay'
      }

      if (methodName === 'antilopay_sbp') {
        body.paymentSystem = 'antilopay'
        body.antilopayGateway = 'antilopay_sbp'
      }

      if (methodName === 'antilopay_card') {
        body.paymentSystem = 'antilopay'
        body.antilopayGateway = 'antilopay_cards'
      }

      if (methodName.includes('cardlink')) {
        body.paymentSystem = 'cardlink'
      }

      if (methodName === 'overpay') {
        body.paymentSystem = 'overpay'
      }

      if (methodName === 'overpay_sbp') {
        body.paymentSystem = 'overpay'
      }

      return body
    },

    choosePaymentMethod(method, isLava = false) {
      this.selectedMethod.method = null
      this.selectedMethod.percent = null
      this.selectedMethod.status = null

      this.error = {
        status: false,
        show: false,
        message: ''
      }
      this.emailError = {
        status: false,
        show: false,
        message: ''
      }

      this.selectedMethod.name = method.key
      this.selectedMethod.key = method.key
      this.selectedMethod.method = method.key
      this.selectedMethod.currency = method.currency
      this.selectedMethod.commission = method.commission
      this.selectedMethod.iconType = method.iconType
      this.selectedMethod.min = method.min
      this.selectedMethod.email = method.email
      this.selectedMethod.iconName = method.iconName

      if (isLava) {
        this.selectedMethod = { ...method }
        this.selectedMethod.name = 'lava'
        this.selectedMethod.min = 10
        this.selectedMethod.iconName = method.iconName
      }
    },

    validatePrice() {
      const isCustomMinValue = ['lava', 'rub_card', 'sbp_gm', 'card_gm', ...METHODS_ORDER].includes(
        this.selectedMethod?.name
      )
      const min = isCustomMinValue ? this.selectedMethod?.min : 100

      if (isNaN(this.amount)) {
        this.error.status = false
        this.error.show = true
        this.error.message = 'Введите корректную сумму'
      } else if (this.amount < min) {
        this.error.status = false
        this.error.show = true
        this.error.message = `Сумма пополнения должна быть не менее ${min}`
      } else {
        this.error.status = true
        this.error.show = false
        this.error.message = ''
      }
    },

    validateEmail() {
      let errorMessage = ''
      let emailState = true

      if (this.email.length === 0) {
        errorMessage = 'Поле E-mail пустое'
        emailState = false
      } else if (validateEmail(this.email) === false) {
        errorMessage = 'Введённая почта неверная!'
        emailState = false
      } else {
        errorMessage = ''
        emailState = true
      }

      this.emailError.status = emailState
      this.emailError.show = !emailState
      this.emailError.message = errorMessage
    },

    async getNewCommission() {
      try {
        const response = await fetch('https://payments.backend-pier.com/api/v1/topups/lava_commissions')
        const data = await response.json()
        const { commissions } = data
        this.newCommissions = commissions
          ?.filter(item => item.status)
          .map(item => {
            return { ...item, name: 'lava', key: 'lava_' + item.method }
          })
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },

    getMethodsWithOrder(currentList) {
      const filteredList = []

      METHODS_ORDER.forEach(methodName => {
        const method = currentList.find(item => item.key === methodName)
        if (method) filteredList.push(method)
      })
      return filteredList
    },

    shouldReturnUnknown(method) {
      return ['new_fk', 'payok'].includes(method)
    },

    isQiwiMethod(method) {
      return method === 'qiwi'
    },

    calculateQiwiCommission() {
      const commission = this.methodMaps.qiwi.commission
      return Math.ceil((Number(this.amount) + (this.amount * commission) / 100) * 100) / 100
    },

    calculateCommissionRate(method) {
      if (this.selectedMethod.percent) {
        return Number(1 - this.selectedMethod.percent) * 100
      }

      const methodCommission = this.methodMaps[method]?.commission

      if (typeof methodCommission !== 'object') {
        return methodCommission
      }

      return methodCommission[this.filters.country] || methodCommission.default
    },

    getPrice(amount, commission, multiplier = 0, useLavaFormula = false) {
      if (useLavaFormula) {
        const resultLava = amount / (1 - commission / 100)
        return Number(resultLava.toFixed(2))
      }

      const result = amount + (amount * commission) / 100 + multiplier
      return Number(result.toFixed(2))
    },

    shouldUseLavaCalculation(method) {
      return this.selectedMethod.percent || ['cardlink', 'cardlink_sbp', 'cardlink_copy', 'lava'].includes(method)
    },

    calculateWithMultipliers(method, amount, commission) {
      const multipliers = {
        redpagos: {
          RUB: 0.5 * this.currencyRate.USD,
          EUR: 0.5 * this.currencyRate.USDEUR,
          USD: 0.5
        },
        servipag: {
          RUB: 1.5 * this.currencyRate.USD,
          EUR: 1.5 * this.currencyRate.USDEUR,
          USD: 1.5
        },
        boleto: {
          RUB: this.currencyRate.USD,
          EUR: this.currencyRate.USDEUR,
          USD: 1
        }
      }

      if (multipliers[method] && multipliers[method][this.currency]) {
        return this.getPrice(amount, commission, multipliers[method][this.currency])
      }

      if (method === 'card_gm') {
        return this.calculateCardGmCommission(amount, commission)
      }

      return null
    },

    calculateCardGmCommission(amount, commission) {
      const cardGmMultipliers = {
        EU: {
          RUB: 0.1 * this.currencyRate.EUR,
          EUR: 0.1,
          USD: 0.1 * this.currencyRate.EURUSD
        },
        default: {
          RUB: 0.12 * this.currencyRate.EUR,
          EUR: 0.12,
          USD: 0.12 * this.currencyRate.EURUSD
        }
      }

      const multiplierConfig = ['RU', 'UA', 'EU'].includes(this.filters.country)
        ? cardGmMultipliers.EU
        : cardGmMultipliers.default

      if (multiplierConfig[this.currency]) {
        return this.getPrice(amount, commission, multiplierConfig[this.currency])
      }

      return null
    },

    calculateGramCommission(amount) {
      const c = Number(amount / 7).toFixed(2)
      const minCommission = 4.9 / this.currencyRate[this.currency]

      if (c > minCommission) {
        return Math.ceil((amount + Number(c)) * 100) / 100
      } else {
        return Math.ceil((amount + minCommission) * 100) / 100
      }
    }
  }
}
</script>

<style lang="scss">
@import './transferPaymentMethod.scss';
</style>
